// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { router } from './router'
import axios from 'axios'
import API from './API'
import Store from './Store'
import BootstrapVue from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueMoment from 'vue-moment'
import VueScrollTo from'vue-scrollto'

import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize
} from "vee-validate";
import ru from "vee-validate/dist/locale/ru.json";
import * as rules from "vee-validate/dist/rules";

import helpers from './helpers'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/admin-panel.css'
import './assets/css/main.css'

import './assets/js/main.js'

const plugin = {
  install () {
    Vue.helpers = helpers
    Vue.prototype.$helpers = helpers
  }
}
Vue.use(plugin)

// Install VeeValidate rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});
localize("ru", ru);
// Install VeeValidate components globally
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

Vue.use(VueScrollTo)


library.add(fas)

Vue.component('font-awesome-icon', FontAwesomeIcon)

// axios.defaults.baseURL = 'http://oostin.beget.tech';
axios.defaults.baseURL = 'https://rls.doctor';

let access_token = Store.getters['Auth/getAccessToken']
if (access_token)
  axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;

Vue.use(BootstrapVue)
Vue.use(VueMoment)
Vue.config.productionTip = false

window.axios = axios
window.API = API
window.Store = Store
window.Vue = Vue;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js